<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Shot4`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.82605 7C4.82605 5.34315 6.16919 4 7.82605 4H19.9998C21.6566 4 22.9998 5.34315 22.9998 7V9.36352L23 9.38351L22.9999 12.1165C22.9999 12.6045 22.6044 13 22.1164 13C21.6285 13 21.2329 12.6044 21.2329 12.1165L21.233 9.38348C21.233 9.35874 21.234 9.33424 21.236 9.31002L21.236 7.29387C21.236 6.52067 20.6092 5.89386 19.836 5.89386H8.02471C7.25151 5.89386 6.62471 6.52067 6.62471 7.29387L6.62479 16.766C6.62479 17.5392 7.25159 18.166 8.02479 18.166H10.282L11.5517 18.1584C12.0625 18.1553 12.4781 18.5684 12.4781 19.0792C12.4781 19.5877 12.0659 20 11.5573 20L7.82605 20C6.16919 20 4.82605 18.6569 4.82605 17V15.8937L3.49334 17.0715C2.52505 17.9273 1 17.2398 1 15.9476V8.30476C1 7.01616 2.51759 6.32735 3.48753 7.17569L4.82605 8.34642V7ZM4.82605 11.0039V13.3125L2.91302 15V9.31641L4.82605 11.0039Z" :fill="useCurrentColor ? 'currentColor' : '#333'"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1915 17.3389L18.7094 12.8029H19.788V17.5203H20.8565V18.4578H19.788V20H18.6691V18.4578H15.1915V17.3389ZM18.6691 14.2947H18.6389L16.1491 17.5203H18.6691V14.2947Z" :fill="useCurrentColor ? 'currentColor' : '#333'"/></svg>
</template>
<script>

export default {
  name: 'IconShot4',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
